import { Link } from "react-router-dom";
import moment from "moment-timezone";

const unassignedLeadsColumns = [
  {
    name: "View Lead",
    sortable: false,
    cell: (row) => {
      return <Link target="_blank" rel="noopener noreferrer" to={`/leads/${row._id}`}>View</Link>;
    },
    width: "60px",
  },
  {
    name: "Created at",
    selector: "createdAt",
    sortable: true,
    cell: (row) => {
      return row.createdAt ? moment(row.createdAt).format("M/D/YY - HHmm") : "-";
    },
    minWidth: "80px",
    maxWidth: "110px",
  },
  {
    name: "Name",
    selector: "fullName",
    cell: (row) => {
      return `${row.firstName} ${row.lastName}`;
    },
    sortable: true,
    width: "130px",
  },
  {
    name: "Dates",
    selector: "departureDate",
    sortable: true,
    width: "90px",
    cell: (row) => {
      if (!row.returnDate) {
        return row.departureDate;
      }

      return `${row.departureDate} - ${row.returnDate}`;
    },
  },
  {
    name: "Routing",
    selector: "departureAirport",
    sortable: true,
    width: "100px",
    cell: (row) => {
      return `${row.departureAirport || ''}-${row.arrivalAirport || ''}`;
    },
  },
  {
    name: "Email",
    selector: "email",
    sortable: true,
    wrap: true,
    width: "auto",
    cell: (row) => {
      return <div className="two-line-content">{row.email}</div>;
    },
  },
  {
    name: "Company",
    selector: "companyName",
    sortable: true,
    wrap: true,
    width: "100px",
    hide: 1800,
  },
];

export { unassignedLeadsColumns };
